import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useMediaQuery,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tab,
    Tabs,
    Grid,
    Radio,
    RadioGroup,
    Checkbox,
    FormControlLabel,
    useTheme,
} from '@mui/material';
import filtericon from '../../../assets/Filtericon.png';
import './Filters.css';

function Filters({ setRating, setVegNonVeg }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [selectedRatings, setSelectedRatings] = useState([]); 
    const [selectedVegNonVeg, setSelectedVegNonVeg] = useState('');

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const handleApplyFilters = () => {
        setRating(selectedRatings); 
        setVegNonVeg(selectedVegNonVeg);
        handleClose();
    };

    const handleRatingChange = (event) => {
        const value = event.target.value;
        setSelectedRatings((prevRatings) =>
            prevRatings.includes(value)
                ? prevRatings.filter((r) => r !== value)
                : [...prevRatings, value]
        );
        
    };

    const handleVegNonVegChange = (event) => {
        setSelectedVegNonVeg(event.target.value);
    };

    return (
        <div className="Filters-main-container" style={{margin:0}}>
            <Button
                onClick={handleOpen}
                startIcon={
                    <img src={filtericon} width="20px" height="18px" alt="filter icon" />
                }
                sx={{
                    borderRadius: '22px',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    backgroundColor: '#FFFFFF',
                    color: '#50555C',
                    height: '35px',
                    border: '#000',
                    boxShadow: '0px 0px 4px 0px #0000001A',
                    width: '90px',
                }}
            >
                {t('homescreen.filter-button')}
            </Button>
            <Dialog open={open} onClose={handleClose} width="70%" height="300px" disableScrollLock>
                <DialogTitle className="filters-title">
                    {t('homescreen.filter-title')}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} className="width-of-dialog-box">
                        <Grid item xs={isMobile ? 4 : 5}>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                orientation="vertical"
                                textColor="primary"
                            >
                                <Tab label={t('homescreen.ratings-tab')} />
                                <Tab label={t('homescreen.veg-or-nonveg-tab')} />
                            </Tabs>
                        </Grid>
                        <Grid item xs={isMobile ? 6 : 7}>
                            <div className="css-mhc70k-MuiGrid-root MuiGrid-item">
                                {tabValue === 0 && (
                                    <div className="checkbox--1">
                                        <FormControlLabel
                                            control={<Checkbox checked={selectedRatings.includes('4.5')} onChange={handleRatingChange} value="4.5" />}
                                            label={t('homescreen.ratings-tab-val1')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={selectedRatings.includes('4.0')} onChange={handleRatingChange} value="4.0" />}
                                            label={t('homescreen.ratings-tab-val2')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={selectedRatings.includes('3.5')} onChange={handleRatingChange} value="3.5" />}
                                            label={t('homescreen.ratings-tab-val3')}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={selectedRatings.includes('3.0')} onChange={handleRatingChange} value="3.0" />}
                                            label={t('homescreen.ratings-tab-val4')}
                                        />
                                    </div>
                                )}
                                {tabValue === 1 && (
                                    <RadioGroup value={selectedVegNonVeg} onChange={handleVegNonVegChange}>
                                        <FormControlLabel
                                            value="veg"
                                            control={<Radio />}
                                            label={t('homescreen.veg-or-nonveg-tab-val1')}
                                        />
                                        <FormControlLabel
                                            value="nonveg"
                                            control={<Radio />}
                                            label={t('homescreen.veg-or-nonveg-tab-val2')}
                                        />
                                        <FormControlLabel
                                            value=""
                                            control={<Radio />}
                                            label={t('homescreen.veg-or-nonveg-tab-val3')}
                                        />
                                    </RadioGroup>
                                )}
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className="filters-apply-btn" onClick={handleClose}>{t('homescreen.close-button')}</Button>
                    <Button
                        onClick={handleApplyFilters}
                        variant="contained"
                        className="filters-apply-btn"
                    >
                        {t('homescreen.apply-button')}
                    </Button>{' '}
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Filters;
